import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getTrackedEmailTypesDictionary} from 'src/openapi/admin/apis/EmailDictionaryApi';
import {useAppDispatch} from 'src/store/hooks';

export const useGetTrackedEmailTypeDictionary = () => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => apiDispatch(
        getTrackedEmailTypesDictionary(),
    ), [apiDispatch]);

    return useReadOnlyDataHook({
        initValue: [],
        getDispatchAction,
    });
};
